<script lang="ts" setup>
import UserAvatar from "@/components/UserAvatar.vue";
import { Mate } from "@/types/entity";

defineProps<{
  idx: number;
  mate: Mate;
  voteCount: number;
}>();
</script>
<template>
  <div class="flex gap-2 flex-1 text-xs">
    <div class="w-10 aspect-[3/4] shrink-0">
      <UserAvatar :mate="mate" class="w-full" ratio="3/4" />
    </div>
    <div class="flex flex-col gap-1 py-1">
      <div class="flex items-center gap-1">
        <div class="line-clamp-1">
          {{ mate.name }}
        </div>
        <gender-badge :gender="mate.gender" class="w-3 shrink-0" />
      </div>
      <!-- <span class="badge badge-neutral rounded shrink-0">
        {{ t("Moment.character") }}
      </span> -->
      <div
        class="text-base-content/50 line-clamp-2"
        v-html="mate.bio ? mate.bio : $t('Message.notBio')"
      />
    </div>
  </div>
</template>
